export default __webpack_public_path__ + "static/media/CloseIcon.f3dacf83.svg";